import React, { useEffect, createElement, Component } from 'react';
import { Toaster } from 'sonner';
import { META_PIXEL_ID } from './utils/constants';
// Components
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel
    try {
      const script = document.createElement('script');
      script.text = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${META_PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    } catch (error) {
      console.error('Error initializing Meta Pixel:', error);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProof data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <EmotionalTransition data-id="element-5" />
      <ProductPresentation data-id="element-6" />
      <WhatIsIncluded data-id="element-7" />
      <PackComposite data-id="element-8" />
      <BonusSection data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <TrustBar data-id="element-14" />
      <FAQSection data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />

      <PurchasePopup data-id="element-18" />
      <Toaster data-id="element-19" />
    </div>;
}